"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COUPON_APPLIED_DIALOG_DEFAULTS = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _couponOffer = require("../../utils/couponOffer");
var _couponSuccess = _interopRequireDefault(require("./images/coupon-success.gif"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const COUPON_APPLIED_DIALOG_DEFAULTS = exports.COUPON_APPLIED_DIALOG_DEFAULTS = {
  width: 335,
  borderRadius: 20,
  iconSize: 120,
  actionText: 'Okay',
  savingsSuffix: 'savings with this coupon',
  fontFamily: 'Inter, sans-serif',
  colors: {
    background: '#ffffff',
    title: '#000000',
    savings: '#1eb865',
    savingsBackground: '#ebfff6',
    action: 'var(--primary-button, #714fff)',
    actionText: '#ffffff'
  }
};
const CouponAppliedDialog = _ref => {
  let {
    open = false,
    onClose,
    couponCode,
    title,
    savingsText,
    discountValue,
    actionText = COUPON_APPLIED_DIALOG_DEFAULTS.actionText,
    savingsSuffix = COUPON_APPLIED_DIALOG_DEFAULTS.savingsSuffix,
    colors: colorsProp,
    width = COUPON_APPLIED_DIALOG_DEFAULTS.width,
    borderRadius = COUPON_APPLIED_DIALOG_DEFAULTS.borderRadius,
    iconSize = COUPON_APPLIED_DIALOG_DEFAULTS.iconSize,
    fontFamily = COUPON_APPLIED_DIALOG_DEFAULTS.fontFamily,
    iconSrc = _couponSuccess.default,
    sx = {},
    ...rest
  } = _ref;
  const colors = {
    ...COUPON_APPLIED_DIALOG_DEFAULTS.colors,
    ...colorsProp
  };
  const resolvedTitle = title ?? (couponCode ? `${couponCode} applied` : null);
  const savings = (0, _couponOffer.getCouponSavingsAmount)(discountValue);
  const resolvedSavings = savingsText ?? (savings ? `${savings} ${savingsSuffix}` : null);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Dialog, {
    open: open,
    onClose: onClose,
    PaperProps: {
      elevation: 0,
      sx: {
        m: 0,
        width: `${width}px`,
        maxWidth: '90vw',
        borderRadius: `${borderRadius}px`,
        overflow: 'hidden',
        background: colors.background,
        boxShadow: '0px -4px 10px 0px rgba(0, 0, 0, 0.1)'
      }
    },
    ...rest,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      sx: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
        width: '100%',
        boxSizing: 'border-box',
        px: '20px',
        py: '24px',
        fontFamily,
        ...sx
      },
      children: [iconSrc && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        component: "img",
        src: iconSrc,
        alt: "",
        "aria-hidden": true,
        sx: {
          width: `${iconSize}px`,
          height: `${iconSize}px`,
          objectFit: 'cover',
          pointerEvents: 'none'
        }
      }), (resolvedTitle || resolvedSavings) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          width: '100%'
        },
        children: [resolvedTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            fontFamily,
            fontWeight: 600,
            fontSize: '20px',
            lineHeight: 1.2,
            textAlign: 'center',
            wordBreak: 'break-word',
            color: colors.title,
            m: 0
          },
          children: resolvedTitle
        }), resolvedSavings && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
          sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            borderRadius: '6px',
            background: colors.savingsBackground
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
            sx: {
              fontFamily,
              fontWeight: 600,
              fontSize: '12px',
              lineHeight: '24px',
              letterSpacing: '-0.12px',
              textAlign: 'center',
              color: colors.savings,
              m: 0
            },
            children: resolvedSavings
          })
        })]
      }), actionText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ButtonBase, {
        disableRipple: true,
        onClick: onClose,
        sx: {
          width: '100%',
          height: '48px',
          borderRadius: '12px',
          background: colors.action
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            fontFamily,
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: 1.4,
            color: colors.actionText,
            m: 0
          },
          children: actionText
        })
      })]
    })
  });
};
var _default = exports.default = CouponAppliedDialog;